// HKDSE 2019 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2019Samples_complete_part2 = {
  statistics: [
    {
      id: 'hkdse2019_statistics_01',
      problem: "The following pie chart shows the distribution of the number of rings owned by a group of girls. Pie chart description: A circular pie chart divided into 5 sectors labeled 2, 3, 5, 7, and one unlabeled sector. The sector labeled 2 has an angle of 144°, and the sector labeled 3 has an angle of 54°. The numbers represent the number of rings owned. (a) Write down the mode of this distribution. (b) Find the mean of this distribution. (c) If a girl is randomly selected from the group, find the probability that the selected girl owns more than $3$ rings.",
      problemType: "statistics_pie_chart",
      difficulty: "intermediate",
      description: "Analyzing pie chart data and calculating statistics",
      graphData: {
        nodes: [
          {
            id: "pie_chart_data",
            name: "Pie Chart Data",
            type: "concepts",
            description: "Distribution of rings owned by girls",
            value: "Sectors: 2 rings (144°), 3 rings (54°), 5 rings, 7 rings, unlabeled",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "mode",
            name: "Mode",
            type: "concepts",
            description: "Most frequent value in distribution",
            value: "Mode = 2 rings",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "mean_calculation",
            name: "Mean Calculation",
            type: "methods",
            description: "Calculating average number of rings",
            value: "Mean = Σ(x × frequency) / total frequency",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "probability",
            name: "Probability",
            type: "concepts",
            description: "Probability of selecting girl with >3 rings",
            value: "P(>3 rings) = favorable/total",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "pie_chart_data",
            to: "mode",
            type: "determines",
            strength: 9
          },
          {
            from: "pie_chart_data",
            to: "mean_calculation",
            type: "provides_data",
            strength: 9
          },
          {
            from: "pie_chart_data",
            to: "probability",
            type: "provides_data",
            strength: 8
          }
        ]
      }
    }
  ],
  mensuration: [
    {
      id: 'hkdse2019_mensuration_01',
      problem: "The sum of the volumes of two spheres is $324\\pi$ cm$^3$. The radius of the larger sphere is equal to the diameter of the smaller sphere. Express the answers in terms of $\\pi$. (a) Find the volume of the larger sphere. (b) Find the sum of the surface areas of the two spheres.",
      problemType: "mensuration_spheres",
      difficulty: "intermediate",
      description: "Working with sphere volumes and surface areas",
      graphData: {
        nodes: [
          {
            id: "sphere_volumes",
            name: "Sphere Volumes",
            type: "concepts",
            description: "Volume relationship between two spheres",
            value: "V₁ + V₂ = 324π cm³",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "radius_relationship",
            name: "Radius Relationship",
            type: "concepts",
            description: "Larger sphere radius equals smaller sphere diameter",
            value: "R = 2r",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "volume_formula",
            name: "Volume Formula",
            type: "formulas",
            description: "V = (4/3)πr³",
            value: "V = (4/3)πr³",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "surface_area_formula",
            name: "Surface Area Formula",
            type: "formulas",
            description: "A = 4πr²",
            value: "A = 4πr²",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "radius_relationship",
            to: "sphere_volumes",
            type: "constrains",
            strength: 9
          },
          {
            from: "volume_formula",
            to: "sphere_volumes",
            type: "calculates",
            strength: 9
          },
          {
            from: "surface_area_formula",
            to: "sphere_volumes",
            type: "related_to",
            strength: 8
          }
        ]
      }
    }
  ],
  functions: [
    {
      id: 'hkdse2019_functions_01',
      problem: "It is known that one part of $h(x)$ is a constant, and another part varies directly as $x$. Suppose $h(-2) = -96$ and $h(5) = 72$. (a) Find $h(x)$. (b) Solve the equation $h(x) = 3x^2$.",
      problemType: "functions_direct_variation",
      difficulty: "intermediate",
      description: "Working with functions involving direct variation",
      graphData: {
        nodes: [
          {
            id: "function_structure",
            name: "Function Structure",
            type: "concepts",
            description: "h(x) = constant + kx",
            value: "h(x) = c + kx",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "direct_variation",
            name: "Direct Variation",
            type: "concepts",
            description: "Part of function varies directly with x",
            value: "kx where k is constant",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "system_equations",
            name: "System of Equations",
            type: "methods",
            description: "Using given values to find constants",
            value: "h(-2) = -96, h(5) = 72",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "equation_solving",
            name: "Equation Solving",
            type: "methods",
            description: "Solving h(x) = 3x²",
            value: "Substituting h(x) and solving",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "function_structure",
            to: "direct_variation",
            type: "includes",
            strength: 9
          },
          {
            from: "system_equations",
            to: "function_structure",
            type: "determines",
            strength: 9
          },
          {
            from: "function_structure",
            to: "equation_solving",
            type: "used_in",
            strength: 8
          }
        ]
      }
    }
  ],
  polynomials: [
    {
      id: 'hkdse2019_polynomials_01',
      problem: "Let $\\text{p}(x)$ be a cubic polynomial. When $\\text{p}(x)$ is divided by $x - 1$, the remainder is $50$. When $\\text{p}(x)$ is divided by $x + 2$, the remainder is $-52$. It is known that $\\text{p}(x)$ is divisible by $2x^2 + 9x + 14$. (a) Find the quotient when $\\text{p}(x)$ is divided by $2x^2 + 9x + 14$. (b) How many rational roots does the equation $\\text{p}(x) = 0$ have? Explain your answer.",
      problemType: "polynomials_remainder_factor",
      difficulty: "advanced",
      description: "Working with polynomial division and remainder theorem",
      graphData: {
        nodes: [
          {
            id: "remainder_theorem",
            name: "Remainder Theorem",
            type: "concepts",
            description: "p(1) = 50, p(-2) = -52",
            value: "p(a) = remainder when divided by (x-a)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "polynomial_division",
            name: "Polynomial Division",
            type: "methods",
            description: "Dividing by quadratic factor",
            value: "p(x) = (2x² + 9x + 14) × quotient",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "rational_roots",
            name: "Rational Roots",
            type: "concepts",
            description: "Finding rational solutions",
            value: "Using rational root theorem",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "cubic_polynomial",
            name: "Cubic Polynomial",
            type: "concepts",
            description: "Degree 3 polynomial",
            value: "p(x) = ax³ + bx² + cx + d",
            importance: 9,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "remainder_theorem",
            to: "cubic_polynomial",
            type: "applied_to",
            strength: 9
          },
          {
            from: "polynomial_division",
            to: "cubic_polynomial",
            type: "factorizes",
            strength: 9
          },
          {
            from: "rational_roots",
            to: "cubic_polynomial",
            type: "finds_zeros",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics_advanced: [
    {
      id: 'hkdse2019_statistics_advanced_01',
      problem: "The following stem-and-leaf diagram shows the distribution of results (in seconds) of some male students in a $400$ m race. Stem-and-leaf table description: Stem (tens digit) represents tens place, Leaf (units digit) represents units place. Row 1: Stem 5, Leaves: a. Row 2: Stem 6, Leaves: 0 0 3 c c 8 9 9 9. Row 3: Stem 7, Leaves: 0 1 1 1 2 2 5 6 9. Row 4: Stem 8, Leaves: b. It is known that the interquartile range of this distribution is $8$ seconds. (a) Find $c$. (b) It is known that the range of this distribution exceeds $34$ seconds and the mean of this distribution is $69$ seconds. Find (i) $a$ and $b$; (ii) the smallest possible standard deviation of this distribution.",
      problemType: "statistics_stem_leaf",
      difficulty: "advanced",
      description: "Analyzing stem-and-leaf diagram with missing values",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_diagram",
            name: "Stem-and-Leaf Diagram",
            type: "concepts",
            description: "Data representation with stems and leaves",
            value: "5|a, 6|003cc8999, 7|011122569, 8|b",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "interquartile_range",
            name: "Interquartile Range",
            type: "concepts",
            description: "IQR = Q3 - Q1 = 8 seconds",
            value: "IQR = 8",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "missing_values",
            name: "Missing Values",
            type: "variables",
            description: "a, b, c to be determined",
            value: "a, b, c",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "statistical_constraints",
            name: "Statistical Constraints",
            type: "concepts",
            description: "Range > 34, Mean = 69",
            value: "Range > 34, Mean = 69",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "stem_leaf_diagram",
            to: "missing_values",
            type: "contains",
            strength: 9
          },
          {
            from: "interquartile_range",
            to: "missing_values",
            type: "constrains",
            strength: 9
          },
          {
            from: "statistical_constraints",
            to: "missing_values",
            type: "constrains",
            strength: 8
          }
        ]
      }
    }
  ],
  geometry_advanced: [
    {
      id: 'hkdse2019_geometry_advanced_01',
      problem: "In Figure 1, $O$ is the center of circle $ABCDE$. $AC$ is a diameter of the circle. $BD$ and $OC$ intersect at point $F$. It is known that $\\angle AED = 115°$. Figure 1 description: A circle with center O and points A, B, C, D, E on the circumference. AC is a diameter passing through center O. Lines BD and OC intersect at point F inside the circle. (a) Find $\\angle CBF$. (b) Suppose $BC \\parallel OD$ and $OB = 18$ cm. Is the perimeter of sector $OBC$ less than $60$ cm? Explain your answer.",
      problemType: "geometry_circle_theorems",
      difficulty: "advanced",
      description: "Applying circle theorems and sector calculations",
      graphData: {
        nodes: [
          {
            id: "circle_theorems",
            name: "Circle Theorems",
            type: "concepts",
            description: "Angles in circles and cyclic quadrilaterals",
            value: "Angle properties in circles",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "diameter_property",
            name: "Diameter Property",
            type: "concepts",
            description: "AC is diameter, angle in semicircle = 90°",
            value: "Angle in semicircle = 90°",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "sector_perimeter",
            name: "Sector Perimeter",
            type: "concepts",
            description: "Perimeter of sector OBC",
            value: "P = 2r + arc length",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "parallel_lines",
            name: "Parallel Lines",
            type: "concepts",
            description: "BC parallel to OD",
            value: "BC ∥ OD",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "circle_theorems",
            to: "diameter_property",
            type: "includes",
            strength: 9
          },
          {
            from: "diameter_property",
            to: "sector_perimeter",
            type: "affects",
            strength: 8
          },
          {
            from: "parallel_lines",
            to: "sector_perimeter",
            type: "constrains",
            strength: 7
          }
        ]
      }
    }
  ]
}; 